jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })
 

  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();
  
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });
  
  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });
  
    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');
    });
  });

/* Fix: iubenda Cookie-Schloss ueber Widerruf-Button heben */
(function(){function f(){var b=document.querySelector('.iubenda-tp-btn.iubenda-cs-preferences-link');if(b){b.style.setProperty('top','auto','important');b.style.setProperty('bottom','90px','important');}}function i(){f();try{new MutationObserver(f).observe(document.body,{childList:true,subtree:true});}catch(e){}window.addEventListener('scroll',f);window.addEventListener('resize',f);}if(document.readyState=='loading'){document.addEventListener('DOMContentLoaded',i);}else{i();}})();